import React from "react";

interface ProgressBarProps {
    percentage: number;
    height?: string;
    backgroundColor?: string;
    foregroundColor?: string;
}
export const ProgressBar = (props: ProgressBarProps) => {
    return (
        <div className={`bg-${props.backgroundColor || 'background-default'} ${props.height || 'h-2.5'} w-full rounded-full`}>
            <div
                role='progressbar'
                aria-valuenow={props.percentage}
                aria-valuemin={0}
                aria-valuemax={100}
                className={`bg-${props.foregroundColor || 'brand-primary'} ${props.height || 'h-2.5'} rounded-full transition-all duration-300`}
                style={{ width: `${props.percentage}%` }}
            />
        </div>
    );
}
export default ProgressBar;